const SubjectInfo = {
    SubjectId: 0,
    Name: "",
    Description: "",
    Examid: 0,
    Active: true,
    UserId: 0,
    CreatedDate: new Date(),
    QuestionCount: 0,
    PartnerId: 0,
    encPartnerID: ""
}
